"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/offerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type OfferSection12126sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/category/offer-img-1.jpg" | "/Templates/Doccure/img/category/offer-img-2.jpg" | "/Templates/Doccure/img/category/offer-img-3.jpg" | "/Templates/Doccure/img/category/offer-img-4.jpg" | "/Templates/Doccure/img/category/offer-img-5.jpg" */
    src: string;
    /** Detected variants: "Individual Therapy" | "Couples Counseling" | "Anxiety Treatment" | "Anger Management" | "Mindfulness Therapy" */
    h30Text: ReactNode;
    /** Detected variants: "One on one sessions tailored to your needs and goals. Work through challenges on own pace with support." | "Strengthen your relationship and improve communication. Navigate challenges together with expert guidance." | "Helps manage excessive worry, fear, and panic through proven therapy techniques and coping strategies." | "Helps control anger, improve emotional regulation, and develop healthier communication skills." | "Learn relaxation and mindfulness techniques to reduce stress and improve mental clarity of your life" */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-12 col-lg-12 col-md-6" */
    className?: string;
    /** Detected variants: "offers-item-fifteen wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "2s" */
    dataWowDuration?: string;
    /** Detected variants: "offers-overlay" */
    div0ClassName2?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "overlay-img img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "offers-content" */
    div1ClassName?: string;
    /** Detected variants: "offers-title" */
    h30ClassName?: string;
    /** Detected variants: "offers-description" */
    p0ClassName?: string;
    /** Detected variants: "flower" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid element-1" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/flower-icon.svg" */
    imageWithBasePath0Src?: string;
    /** Detected variants: "View service" */
    ariaLabel?: string;
    /** Detected variants: "btn-icon" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
};
export type HomeFifteenOfferSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: OfferSection12126sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: OfferSection12126sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: OfferSection12126sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: OfferSection12126sItem) => Partial<ComponentProps<typeof SmartLink>>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "2s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "What We Offer" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "#" */
    sectionDiv0Div0Div0Div0Div1Link0LinkHref?: string;
    /** Default: "View All Services" */
    sectionDiv0Div0Div0Div0Div1Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div0Div1Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Comprehensive Care" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    /** Default: "for Your" */
    sectionDiv0Div0Div0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Well-Being" */
    sectionDiv0Div0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "We offer a range of therapeutic services designed to support" */
    sectionDiv0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "your mental health journey, wherever you are in life." */
    sectionDiv0Div0Div0Div0P0PText2?: ReactNode;
    sectionDiv0Div0Div1Div0ClassName?: string;
    /** Default: "" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/round-element-5.svg" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    offerSection12126s: OfferSection12126sItem[];
    offerSection12126sItemWrapper?: (item: OfferSection12126sItem, content: ReactNode) => ReactNode;
    offerSection12126sRenderer?: (defaultNode: ReactNode) => ReactNode;
    offerSection12126sLinkVisible?: boolean;
    offerSection12126sLinkRenderer?: (item: OfferSection12126sItem, defaultNode: ReactNode) => ReactNode;
    offerSection12126sImageVisible?: boolean;
    offerSection12126sImageRenderer?: (item: OfferSection12126sItem, defaultNode: ReactNode) => ReactNode;
    offerSection12126sH3Visible?: boolean;
    offerSection12126sH3Renderer?: (item: OfferSection12126sItem, defaultNode: ReactNode) => ReactNode;
    offerSection12126sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: OfferSection12126sItem) => Partial<ComponentProps<typeof SmartLink>>);
    offerSection12126sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: OfferSection12126sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    offerSection12126sH3Props?: Partial<ComponentProps<"h3">> | ((item: OfferSection12126sItem) => Partial<ComponentProps<"h3">>);
};

const HomeFifteenOfferSectionGenerated: FC<HomeFifteenOfferSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivText = "What We Offer",
    sectionDiv0Div0Div0Div0Div1Link0LinkHref = "#",
    sectionDiv0Div0Div0Div0Div1Link0LinkText = "View All Services",
    sectionDiv0Div0Div0Div0Div1Link0LinkVisible,
    sectionDiv0Div0Div0Div0Div1Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Div1Link0LinkProps,
    sectionDiv0Div0Div0Div0DivDataWowDuration = "2s",
    sectionDiv0Div0Div0Div0H20H2Text = "Comprehensive Care",
    sectionDiv0Div0Div0Div0H20H2Text2 = "for Your",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0SpanText = "Well-Being",
    sectionDiv0Div0Div0Div0P0PText = "We offer a range of therapeutic services designed to support",
    sectionDiv0Div0Div0Div0P0PText2 = "your mental health journey, wherever you are in life.",
    sectionImageWithBasePath0ImageAlt = "",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/round-element-5.svg",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0H30H3Props,
    divDiv0Div1ImageWithBasePath0ImageProps,
    divDiv0Div1Link0LinkProps,
    sectionDiv0Div0ClassName,
    sectionDiv0Div0Div1Div0ClassName,
    offerSection12126s,
    offerSection12126sItemWrapper,
    offerSection12126sRenderer,
    offerSection12126sLinkVisible,
    offerSection12126sLinkRenderer,
    offerSection12126sImageVisible,
    offerSection12126sImageRenderer,
    offerSection12126sH3Visible,
    offerSection12126sH3Renderer,
    offerSection12126sLinkProps,
    offerSection12126sImageProps,
    offerSection12126sH3Props,
}) => {
    return (
        <section className="section offer-section-fifteen">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row row-gap-5"}>
                    <div className="col-lg-6">
                        <div className="section-header-fifteen wow fadeInUp" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            <div className="section-sub-title">{sectionDiv0Div0Div0Div0Div0DivText}</div>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H20H2Text}
                                    <br />
                                    {sectionDiv0Div0Div0Div0H20H2Text2}
                                    <span>{sectionDiv0Div0Div0Div0H20Span0SpanText}</span>
                                </h2>
                            ))}
                            <p className="description">
                                {sectionDiv0Div0Div0Div0P0PText}
                                {" "}
                                <br />
                                {sectionDiv0Div0Div0Div0P0PText2}
                            </p>
                            <div className="view-more">
                                {renderNode(sectionDiv0Div0Div0Div0Div1Link0LinkVisible, sectionDiv0Div0Div0Div0Div1Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div0Div1Link0LinkHref} className="btn btn-white" {...(sectionDiv0Div0Div0Div0Div1Link0LinkProps ?? {})}>
                                        {sectionDiv0Div0Div0Div0Div1Link0LinkText}
                                        {" "}
                                        <span className="icon">
                                            <i>
                                                <i className="isax isax-arrow-right-1" />
                                            </i>
                                        </span>
                                        {" "}
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className={sectionDiv0Div0Div1Div0ClassName ?? "row row-gap-4"}>
                            {renderCollectionNode(
                                offerSection12126s,
                                (item: OfferSection12126sItem) => (
                                    <div className={item.className ?? "col-xl-12 col-lg-12 col-md-6"} key={item.key}>
                                        <div className={item.div0ClassName ?? "offers-item-fifteen wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "2s"}>
                                            <div className={item.div0ClassName2 ?? "offers-overlay"}>
                                                {renderItemNode(offerSection12126sImageVisible, offerSection12126sImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "overlay-img img-fluid"} {...(typeof offerSection12126sImageProps === "function" ? offerSection12126sImageProps(item) : (offerSection12126sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </div>
                                            <div className={item.div1ClassName ?? "offers-content"}>
                                                <div>
                                                    {renderItemNode(offerSection12126sH3Visible, offerSection12126sH3Renderer, item, (
                                                        <h3 className={item.h30ClassName ?? "offers-title"} {...(typeof offerSection12126sH3Props === "function" ? offerSection12126sH3Props(item) : (offerSection12126sH3Props ?? {}))} {...(typeof divDiv0Div1Div0H30H3Props === "function" ? divDiv0Div1Div0H30H3Props(item) : (divDiv0Div1Div0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                    ))}
                                                    <p className={item.p0ClassName ?? "offers-description"}>{item.p0Text}</p>
                                                </div>
                                                {renderItemNode(offerSection12126sImageVisible, offerSection12126sImageRenderer, item, (
                                                    <SmartImage src={item.imageWithBasePath0Src ?? "/Templates/Doccure/img/icons/flower-icon.svg"} alt={item.imageWithBasePath0Alt ?? "flower"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid element-1"} {...(typeof offerSection12126sImageProps === "function" ? offerSection12126sImageProps(item) : (offerSection12126sImageProps ?? {}))} {...(typeof divDiv0Div1ImageWithBasePath0ImageProps === "function" ? divDiv0Div1ImageWithBasePath0ImageProps(item) : (divDiv0Div1ImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                                {renderItemNode(offerSection12126sLinkVisible, offerSection12126sLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "btn-icon"} aria-label={item.ariaLabel ?? "View service"} {...(typeof offerSection12126sLinkProps === "function" ? offerSection12126sLinkProps(item) : (offerSection12126sLinkProps ?? {}))} {...(typeof divDiv0Div1Link0LinkProps === "function" ? divDiv0Div1Link0LinkProps(item) : (divDiv0Div1Link0LinkProps ?? {}))}>
                                                        <i>
                                                            <i className={item.i0ClassName ?? "isax isax-arrow-right-1"} />
                                                        </i>
                                                    </SmartLink>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ),
                                offerSection12126sItemWrapper,
                                offerSection12126sRenderer
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="img-fluid round-element-5 d-none d-lg-block" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeFifteenOfferSectionGenerated;
